import { FilterConfigStatic } from '@/types/filter';
import { Filter } from '@cubejs-client/core';
import { FilterValue } from '@/models';
import { PARTNERSCORE_CUBE_NAME } from '@/api/hcp';
import { buildRangeMultiselectFilter } from './utils';

const NPS_MEMBER = `${PARTNERSCORE_CUBE_NAME}.response_nps_q1`;
const NO_DATA_VALUE = '-';

const npsFilter: FilterConfigStatic = {
  label: 'global.filters.formControls.npsScoreLabel',

  options: [
    { value: '9-10', label: 'Promoters (9-10)' },
    { value: '7-8', label: 'Passives (7-8)' },
    { value: '0-6', label: 'Detractors (0-6)' },
    { value: NO_DATA_VALUE, label: 'No data available' },
  ],

  defaultValue: [],
  type: 'multiselect',
  searchable: true,
  clearable: true,
  placeholder: 'global.filters.formControls.npsScorePlaceholder',

  applyFilter: (filterValue: FilterValue): Filter | undefined =>
    buildRangeMultiselectFilter(NPS_MEMBER, filterValue, NO_DATA_VALUE),
};

export default npsFilter;
